import { useState, useEffect } from 'react';

const KEY = 'animationsEnabled';

function getEnabled(): boolean {
  return localStorage.getItem(KEY) !== 'false'; // default true
}

function applyToBody(enabled: boolean): void {
  document.body.dataset.animations = enabled ? 'on' : 'off';
}

/**
 * Global animations toggle. Persists in localStorage.
 * Sets body[data-animations="on|off"] so CSS can kill all animations at once.
 * Also respects prefers-reduced-motion — that's handled in CSS.
 */
export function useAnimations() {
  const [enabled, setEnabled] = useState<boolean>(() => {
    const val = getEnabled();
    applyToBody(val);
    return val;
  });

  useEffect(() => {
    applyToBody(enabled);
  }, [enabled]);

  const toggleAnimations = () => {
    const next = !enabled;
    localStorage.setItem(KEY, String(next));
    setEnabled(next);
  };

  return { animationsEnabled: enabled, toggleAnimations };
}
